import * as config from 'config';

export const getError = (responseData) => responseData?.errors?.error || responseData?.errors || responseData?.error;

export const getErrorMessage = (errorOrData, strategyName = 'DEFAULT') => {
  const errorHandlingStrategies = {
    DEFAULT: config.DEFAULT_ERROR_MESSAGE,
    GENERIC: config.GENERIC_ERROR_MESSAGE,
    BAD_REQUEST: config.GENERIC_ERROR_MESSAGE,
  };
  const fallback = errorHandlingStrategies[strategyName] || errorHandlingStrategies.DEFAULT;

  const data = errorOrData?.response?.data || errorOrData;
  const status = errorOrData?.response?.status;

  if ((strategyName === 'BAD_REQUEST' || strategyName === 'GENERIC') && status !== 400) {
    return fallback;
  }

  const error = getError(data);
  return error?.[0]?.description || error?.[0]?.message || fallback;
};

export default {
  getError,
  getErrorMessage,
};
